import styled from 'styled-components';

/**
 * The one line the merchant wrote about their problem.
 *
 * Capped at one line: a subject is a sentence the bot summarised and can run
 * long, and a row that grows to three lines stops the list being scannable by
 * age, which is the only order it has.
 */
export const RowSubject = styled.div`
  /* 700, the app's bold: this line is what the row is about, and everything
     around it - the reference, the merchant, the age - is context for it. */
  font-weight: 700;
  color: ${({ theme }) => theme.darkGray};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
